import store from '@/store/index.js'
import { SETTING_TYPES, NOT_SET } from '@/utils/UserSettings.js'
export class DataTableColumn {
  id
  text
  textAbbr
  align
  value
  width
  visible
  hidable
  group
  columnAdjusterText
  sort
  cellClass
  aggregateType
  weightedBy
  constructor ({
    id,
    text,
    textAbbr = undefined,
    align,
    value,
    width,
    tooltip = '',
    visible = true,
    invisible = false,
    hidable = true,
    format = undefined,
    total = undefined,
    group = undefined,
    columnAdjusterText = undefined,
    sort = undefined,
    cellClass = undefined,
    aggregateType = undefined,
    weightedBy = undefined
  }) {
    this.id = id
    this.text = text
    this.textAbbr = textAbbr
    this.width = width
    this.align = align
    this.value = value
    this.visible = visible
    this.invisible = invisible
    this.hidable = hidable
    this.tooltip = tooltip
    this.format = format
    this.total = total
    this.group = group
    this.columnAdjusterText = columnAdjusterText
    this.sort = sort
    this.cellClass = cellClass
    this.aggregateType = aggregateType
    this.weightedBy = weightedBy
  }

  clone () {
    return new DataTableColumn(this)
  }

  setCellClass (cellClass) {
    this.cellClass = cellClass
  }
}

export class ColumnSet {
  columns
  setName
  userSettingKey

  constructor ({
    columns,
    setName,
    userSettingKey
  }) {
    this.setName = setName
    this.columns = columns
    this.userSettingKey = userSettingKey

    if (process.env.NODE_ENV === 'development') {
      const columnIdSet = new Set(this.columns.map(c => c.id))
      console.assert(columnIdSet.size === this.columns.length, `Column set ${setName} has at least ${this.columns.length - columnIdSet.size} duplicate column ID(s).`)
    }

    if (this.userSettingKey) {
      const hiddenColumnIds = store.getters['user-settings/mutatedUserSettings'][SETTING_TYPES.TABLE][this.userSettingKey]
      if (hiddenColumnIds && hiddenColumnIds !== NOT_SET) {
        this.columns.forEach(column => this.showColumn(column.id))
        hiddenColumnIds.forEach(columnId => {
          this.hideColumn(columnId)
        })
      }
    }
  }

  getColumns () {
    return this.columns.filter(c => c.visible && !c.invisible)
  }

  getAdjustableColumns () {
    return this.columns.filter(c => c.hidable && !c.invisible)
  }

  getColumnsByGroup (group) {
    return this.columns.filter(c => c.group === group)
  }

  hideColumn (columnId) {
    const columnIndex = this.columns.findIndex(c => c.id === columnId)
    if (columnIndex !== -1) {
      this.columns[columnIndex].visible = false
    }
  }

  showColumn (columnId) {
    const columnIndex = this.columns.findIndex(c => c.id === columnId)
    if (columnIndex !== -1) {
      this.columns[columnIndex].visible = true
    }
  }

  toggleColumn (columnId) {
    const column = this.columns.find(c => c.id === columnId)
    if (column) column.visible = !column.visible
  }

  toggleColumns (columns) {
    const visible = !columns.every(c => c.visible)
    columns.forEach(c => { c.visible = visible })
  }

  isColumnHidden (id) {
    const columnIndex = this.columns.findIndex(c => c.id === id)
    if (columnIndex !== -1) {
      return !this.columns[columnIndex].visible
    } else {
      return true
    }
  }

  getSummableHeaders () {
    return this.columns.filter(c => c.total !== undefined).map(c => c.value)
  }

  commitColumnInfo () {
    if (this.userSettingKey) {
      store.commit('user-settings/mutateUserSetting', {
        type: SETTING_TYPES.TABLE,
        key: this.userSettingKey,
        value: this.columns.filter(c => !c.visible && c.id !== undefined).map(c => c.id)
      })
    }
  }

  saveColumnInfo () {
    if (this.userSettingKey) {
      this.commitColumnInfo()
      store.dispatch('user-settings/updateUserSettings', store.getters['user-settings/mutatedUserSettings'])
    }
  }

  clone () {
    return new ColumnSet({
      columns: this.columns.map(c => c.clone()),
      setName: this.setName,
      userSettingKey: this.userSettingKey
    })
  }
}
